import { ShaderChunk } from "three";
import bsdfs from "../material/bsdfs.glsl";
export function registerCustomShaderChunk(shaderChunkName, shaderSrc) {
    shaderSrc && (ShaderChunk[shaderChunkName] = shaderSrc);
}
ShaderChunk.bsdfs = bsdfs;
